<template>
    <div class="indicators-page" :class="{'loading':loadingNow || renderingNow}">
        <div class="row">
          <h3>Indicators</h3>
          <div class="refresh" @click="getData(1)">
          </div>
        </div>
        <form>
            <div class="activePlaceholderImitation">
              <datepicker
                v-model="filters.immediate.startDate"
                calendar-class='calendar'
                :disabled-dates="{from: new Date(filters.immediate.endDate)}"
                :use-utc='true'
              ></datepicker>
              <span>Start date</span>
            </div>
            <div class="activePlaceholderImitation">
              <datepicker
                v-model="filters.immediate.endDate"
                calendar-class='calendar'
                :disabled-dates="{to: new Date(filters.immediate.startDate)}"
                :use-utc='true'
              ></datepicker>
              <span>End date</span>
            </div>
            <div class="selectWrapper activePlaceholder" :class="{'selected':filters.immediate.exchange}">
              <v-select v-model="filters.immediate.exchange" :options="exchangesList"></v-select>
              <span>Exchange</span>
            </div>
            <div class="selectWrapper activePlaceholder" :class="{'selected':filters.immediate.symbol}">
              <v-select v-model="filters.immediate.symbol" :options="symbolsList"></v-select>
              <span>Symbol</span>
            </div>
            <div class="selectWrapper activePlaceholder" :class="{'selected':filters.immediate.type}">
              <v-select v-model="filters.immediate.type" :options="typesList"></v-select>
              <span>Type</span>
            </div>
            <div class="selectWrapper activePlaceholder" :class="{'selected':filters.immediate.name}">
              <v-select v-model="filters.immediate.name" :options="namesList"></v-select>
              <span>Name</span>
            </div>

            <div class="amount">
              <div class="moreLess">
                <div class="less" :class="{'active':!moreSelected.price}" @click="moreSelected.price = false; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
                <div class="more" :class="{'active':moreSelected.price}" @click="moreSelected.price = true; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
              </div>
              <div class="activePlaceholder">
                <input type="number" placeholder=" " v-model="filters.throttle.price">
                <span>Price</span>
              </div>
            </div>

            <div class="amount">
              <div class="moreLess">
                <div class="less" :class="{'active':!moreSelected.ratio}" @click="moreSelected.ratio = false; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
                <div class="more" :class="{'active':moreSelected.ratio}" @click="moreSelected.ratio = true; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
              </div>
              <div class="activePlaceholder">
                <input type="number" placeholder=" " v-model="filters.throttle.ratio">
                <span>Ratio</span>
              </div>
            </div>

            <div class="amount">
              <div class="moreLess">
                <div class="less" :class="{'active':!moreSelected.delta}" @click="moreSelected.delta = false; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
                <div class="more" :class="{'active':moreSelected.delta}" @click="moreSelected.delta = true; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
              </div>
              <div class="activePlaceholder">
                <input type="number" placeholder=" " v-model="filters.throttle.delta">
                <span>Delta</span>
              </div>
            </div>

            <div class="amount">
              <div class="moreLess">
                <div class="less" :class="{'active':!moreSelected.bids_quantity}" @click="moreSelected.bids_quantity = false; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
                <div class="more" :class="{'active':moreSelected.bids_quantity}" @click="moreSelected.bids_quantity = true; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
              </div>
              <div class="activePlaceholder">
                <input type="number" placeholder=" " v-model="filters.throttle.bids_quantity">
                <span>Bids</span>
              </div>
            </div>

            <div class="amount">
              <div class="moreLess">
                <div class="less" :class="{'active':!moreSelected.asks_quantity}" @click="moreSelected.asks_quantity = false; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
                <div class="more" :class="{'active':moreSelected.asks_quantity}" @click="moreSelected.asks_quantity = true; getData()">
                  <img src="../../assets/img/more.svg" alt="">
                </div>
              </div>
              <div class="activePlaceholder">
                <input type="number" placeholder=" " v-model="filters.throttle.asks_quantity">
                <span>Asks</span>
              </div>
            </div>

        </form>
        <div class="indicators-table-container">
          <table class="indicators-table table">
            <thead>
              <tr @click="handleSort">
                <th v-for="item in tableColumns"
                  :key="item[0]" 
                  :data-sort="item[1]" 
                  :class="{'current asc': item[1] == sortField && sortOrder == 'asc', 
                          'current desc': item[1] == sortField && sortOrder == 'desc' }">
                  {{item[0]}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in transactions" :key="item.id">
                <td>{{item.id}}</td>
                <td>{{moment(item.timestamp * 1000).utc().format('MM.DD.YYYY HH:mm:ss')}}</td>
                <td>{{item.exchange}}</td>
                <td>{{item.symbol}}</td>
                <td>{{item.indicator_type}}</td>
                <td class="text-right">{{item.name}}</td>
                <td class="text-right">{{addCommasDecimal(item.price)}}</td>
                <td class="text-right">{{addCommasDecimal(item.ratio)}}</td>
                <td class="text-right">{{addCommasDecimal(item.delta)}}</td>
                <td class="text-right">{{addCommasDecimal(item.bids_quantity)}}</td>
                <td class="text-right">{{addCommasDecimal(item.asks_quantity)}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <paginate
          v-model="currentPage"
          :pageCount="pageAmount"
          :clickHandler="getData"
          prevText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.928066 3.24063L4.63608 0.0756431C4.76156 -0.0140025 4.91737 0.000932952 5.03505 0.000932952C5.50575 0.000932952 5.50366 0.437028 5.50366 0.547511V7.10658C5.50366 7.19998 5.50572 7.65319 5.03505 7.65319C4.91737 7.65319 4.76153 7.66806 4.63608 7.57844L0.928093 4.32524C0.57971 4.07649 0.639907 3.78292 0.639907 3.78292C0.639907 3.78292 0.579682 3.48935 0.928066 3.24063Z" fill="#5371B3"/></svg>'
          nextText='<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.07193 3.24063L1.36392 0.0756431C1.23844 -0.0140025 1.08263 0.000932952 0.964953 0.000932952C0.49425 0.000932952 0.496338 0.437028 0.496338 0.547511V7.10658C0.496338 7.19998 0.494277 7.65319 0.964953 7.65319C1.08263 7.65319 1.23847 7.66806 1.36392 7.57844L5.07191 4.32524C5.42029 4.07649 5.36009 3.78292 5.36009 3.78292C5.36009 3.78292 5.42032 3.48935 5.07193 3.24063Z" fill="#5371B3"/></svg>'
          :containerClass="'pagination'">
        </paginate>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import _ from 'lodash'

export default {
    name: 'Indicators',
    components: {
        Datepicker
    },
    data: () => ({
        loadingNow: false,
        renderingNow: false,
        filters:{
            immediate:{
                startDate: new Date().toUTCString(),
                endDate: new Date().toUTCString(),
                exchange: '',
                symbol: '',
                type: '',
                name:''
            },
            throttle:{
                price: '',
                ratio: '',
                delta: '',
                bids_quantity: '',
                asks_quantity: '',
            }
        },
        moreSelected: {
            price:true,
            ratio:true,
            delta:true,
            bids_quantity:true,
            asks_quantity:true,
        },
        sortField:'id',
        sortOrder:'desc',
        pageAmount: 0,
        currentPage: 1,
        tableColumns:[
            ['ID','id'],
            ['Date (UTC)','timestamp'],
            ['Exchange','exchange'],
            ['Symbol','symbol'],
            ['Type','indicator_type'],
            ['Name','name'],
            ['Price','price'],
            ['Ratio','ratio'],
            ['Delta','delta'],
            ['Bids','bids_quantity'],
            ['Asks','asks_quantity'],
        ],
        NoSortingFields:['name'],
        transactions: [],
        responseHeaders: null
    }),
    watch: {
        // send immediate query
        filtersImmediate: {
            handler(){
                this.getData();
            },
            deep: true
        },
        // send query if user isn't typing for 500ms
        filtersThrottle: {
            handler: _.debounce(function(){
                this.getData();
                }, 500),
            deep: true
        },
    },
    computed:{
        filtersImmediate(){
            return this.filters.immediate;
        },
        filtersThrottle(){
            return this.filters.throttle;
        },
        exchangesList(){
            return (this.responseHeaders && this.pageAmount != 0) ? this.responseHeaders.exchanges.split(', ').sort() : [];
        },
        symbolsList(){
            return (this.responseHeaders && this.pageAmount != 0) ? this.responseHeaders.symbols.split(', ').sort() : [];
        },
        typesList(){
            return (this.responseHeaders && this.pageAmount != 0) ? this.responseHeaders['indicator-types'].split(', ').sort() : [];
        },
        namesList(){
            return (this.responseHeaders && this.pageAmount != 0) ? this.responseHeaders.names.split(', ').sort() : [];
        },
    },
    methods:{
        handleSort(e){
            // SO SORTING fields
            if (this.NoSortingFields.includes(e.target.getAttribute('data-sort'))) return;

            this.sortField = e.target.getAttribute('data-sort');
            this.sortOrder = e.target.classList.contains('asc') ? 'desc' : 'asc';
            this.getData();
        },
        getData(page = 1){
            const queryParameters = {
                params:{
                    page:page
                }
            };
            // create object for IMMEDIATE query from filters
            for (const key in this.filters.immediate) {
                if (this.filters.immediate[key]){
                    // add date formatting
                    if (['startDate','endDate'].includes(key)){
                        queryParameters.params[key] = moment(this.filters.immediate[key]).utc().format('YYYY-MM-DD');
                    }
                    // simple adding
                    else{
                        queryParameters.params[key] = this.filters.immediate[key].toLowerCase();
                    }
                }
            }
            // create object for THROTTLE query from filters
            for (const key in this.filters.throttle) {
              if (this.filters.throttle[key]){
                // if (this.filters.throttle[key].length < 2) return;

                // more filter
                if (this.moreSelected[key]){
                  queryParameters.params[key] = this.filters.throttle[key];
                }
                // less filter
                else{
                  queryParameters.params['less_than_' + key] = this.filters.throttle[key];
                }
              }
            }

            // add sort fields
            queryParameters.params['sort_by'] = this.sortField;
            queryParameters.params['sort_order'] = this.sortOrder.toUpperCase();

            this.loadingNow = true;
            axios.get('indicators/query',queryParameters).then(response => {
                this.currentPage = page;
                this.pageAmount = +response.headers['page-amount'];
                this.responseHeaders = response.headers;
                this.transactions = response.data;

                this.renderingNow = true;
                this.loadingNow = false;
            });
        },
    },
    created(){
        this.getData()
    },
    updated(){
        this.renderingNow = false;
    }
};
</script>
<style lang="scss">
.indicators-page{
    .row{
      display: flex;
      align-items: center;
      h3{
        margin-right: 10px;
      }
    }
    form{
        display: flex;
        flex-wrap: wrap;
        margin: 0px -5px;
        & > *{
            width: 180px !important;
            margin-bottom: 15px;
            margin-right: 5px;
            margin-left: 5px;
            @media (max-width: 1200px) {
              width: calc(25% - 10px) !important;
            }
            @media (max-width: 1000px) {
                width: calc(33.333% - 10px) !important;
            }
            @media (max-width: 650px) {
                width: calc(50% - 10px) !important;
            }
            @media (max-width: 500px) {
                width: calc(100% - 10px) !important;
            }
        }
    }
    .indicators-table-container{
        position: relative;
        @media (max-width: 1100px) {
            overflow-y: hidden;
            overflow-x: scroll;
        }
        .indicators-table{
            width: 100%;
            position: relative;
            min-width: 1100px;
            thead {
                display: table; 
                width: 100%;
            }
            tbody{
                display: block; 
                min-height: 270px;
                max-height: calc(100vh - 83px - 297px);
                overflow-y: scroll;
                tr {
                    display: table;
                    width: 100%;
                }
            }
            th,td{
                width: 9%;
                &:nth-child(1){
                    width: 7%;
                }
                &:nth-child(2){
                    width: 13%;
                }
            }
            td{
                &:nth-child(11){
                    width: 6.5%;
                }
            }
        }
    }
    &.loading{
        pointer-events: none;
        table:before{
            content: "";
            width: 500%;
            height: 100%;
            position: absolute;
            z-index: 5;
            background: var(--loading-bg);
            top:0;
        }
        .indicators-table-container:after{
            content: "";
            width: 64px;
            height: 64px;
            background: url('../../assets/img/loader.svg') no-repeat;;
            position: absolute;
            z-index: 10;
            left:50%;
            top:50%;
            transform: translate(-50%,-50%);
        }
    }
}
</style>
